import { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";

import { faLanguage } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TooltipWrapper } from "../../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { IGlossaryFileSupportExtended } from "../GlossarySelection.types";

interface IGlossarySelectionProps {
  glossary: IGlossaryFileSupportExtended;
}

export const GlossarySelectionOption: FunctionComponent<IGlossarySelectionProps> = (props: IGlossarySelectionProps) => {
  const { t } = useTranslation();
  const optionRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className={classNames("glossary-option-item", {
        empty: !props.glossary.glossaryId,
      })}
      ref={optionRef}
    >
      <TooltipWrapper
        targetRef={optionRef}
        content={props.glossary.supportedLanguageOptions.map(lang => t(lang.labelKey)).join(", ")}
        position="left"
      />
      {props.glossary.name} <FontAwesomeIcon icon={faLanguage} />
    </div>
  );
};
